module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACCSURBVHgBzdPBDcAgCAVQ00ncsG4AG9kNHI3KoYmNH8SbJFzK7yMpaUrHlojk3rU3BbJ376bvoKEOviIHoSH3oECRf9EC0WJrG1tYGPGwbcTB9pEFxlb+8qzgM0eYvwk8wC7C4lwzjAyzGCaBEwOsIKh6iIE1FNCftsEtGNPFOR1bL2Zhn3J4jn4LAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/theme1/common/close-small.png
// module id = 7omG
// module chunks = 319